import { forwardRef, type Ref, type SVGProps } from "react";
const IconLegalOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.122 4.565a.91.91 0 0 0-.855-.7h-9.334v-.933c0-.545-.389-.934-.933-.934s-.933.39-.933.934v.933H5.733a.91.91 0 0 0-.855.7L2.085 13.85a2 2 0 0 0-.085.576v1.572c0 2.022 1.711 3.734 3.733 3.734h3.734c2.022 0 3.733-1.712 3.733-3.734v-1.576q0-.29-.082-.569l-2.408-8.12h4.356v22.403h-5.29s-1.02-.059-1.02.933c0 .991 1.02.933 1.02.933h12.445s.9-.039.9-.933c0-.895-.9-.934-.9-.934h-5.289V5.732h4.356L18.9 13.857a2 2 0 0 0-.08.561l-.003 1.598c0 2.022 1.694 3.716 3.716 3.716h3.734c2.022 0 3.733-1.712 3.733-3.734v-1.572a2 2 0 0 0-.085-.576zm-16.1 8.633H4.178l2.255-7.466h2.334zm-1.555 4.667H5.733c-1.01 0-1.866-.856-1.866-1.867v-.933h7.466v.933c0 1.011-.855 1.867-1.866 1.867m18.355-4.667-2.255-7.466h-2.334l-2.255 7.466zm-1.555 4.667h-3.734c-1.01 0-1.866-.856-1.866-1.867v-.933h7.466v.933c0 1.011-.855 1.867-1.866 1.867"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLegalOutlineSVG);
ForwardRef.displayName = "IconLegalOutline";
export { ForwardRef as IconLegalOutline };
